import { Injectable } from '@angular/core';
import { PredefinedAudioService } from '@nimbus-library/features/shared/services/media/predefined-audio.service';
import { SettingsService } from './settings.service';

@Injectable({ providedIn: 'root' })
export class AudioService extends PredefinedAudioService {
  public constructor(private readonly settingsService: SettingsService) {
    super();
  }

  public override getUrl(audioFile: string): string {
    return `${this.settingsService.portalUrl}/audio/${audioFile}`;
  }
}
